import React, { Component } from 'react';
import CountUp from 'react-countup';

class Attendance extends Component {
  render() {

    if(this.props.attendance !== undefined && this.props.attendance.avg !== null) {
      return (
        <div>
        <div className="section-title">{this.props.yearFilter} Home Attendance</div>
        <div className="attendanceBox">
          <div className="attendance-titles">
            <div className="attendance-title"><p>AVE</p></div>
            <div className="attendance-title"><p>MAX</p></div>
            <div className="attendance-title"><p>TOTAL</p></div>
          </div>
          <div className="attendance-totals">

            <div className="attendance-total">
              <div>
                <p>
                  <CountUp
                    className="custom-count"
                    start={1}
                    end={Number(this.props.attendance.avg)}
                    duration={2.25}
                    useEasing={true}
                    useGrouping={true}
                    separator=","
                    decimal=","
                  />
                </p>
              </div>
            </div>

            <div className="attendance-total">
              <div>
                <p>
                  <CountUp
                    className="custom-count"
                    start={1}
                    end={Number(this.props.attendance.max)}
                    duration={2.5}
                    useEasing={true}
                    useGrouping={true}
                    separator=","
                    decimal=","
                  />
                </p>
              </div>
            </div>

            <div className="attendance-total">
              <div>
                <p>
                  <CountUp
                    className="custom-count"
                    start={1}
                    end={Number(this.props.attendance.total)}
                    duration={2.75}
                    useEasing={true}
                    useGrouping={true}
                    separator=","
                    decimal=","
                  />
                </p>
              </div>
            </div>

          </div>
        </div>
        </div>
      );
    } else {
      return <span></span>;
    }
  }
}

export default Attendance;
